import { render, staticRenderFns } from "./TradingJournal.vue?vue&type=template&id=35d1353a"
import script from "./TradingJournal.vue?vue&type=script&lang=js"
export * from "./TradingJournal.vue?vue&type=script&lang=js"
import style0 from "./TradingJournal.vue?vue&type=style&index=0&id=35d1353a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports